export const ENDPOINTS = {
  admin: {
    list_showcases: (stage: string | number) => `admin/cms/showcase/list/${stage}`,
    detail_showcase: (showcase: string | number) => `admin/cms/showcase/details/${showcase}`,
  },
  non_admin: {
    list_showcase: (stage: string | number) => `cms/showcase/list/${stage}`,
  },
};
